import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { FLAGS } from '@Types/flags';

type FeatureFlagReturn = {
	asyncTestsTimeoutMs: number;
};

export const useFeatureFlagConfiguration = (): FeatureFlagReturn => {
	const systemTestsTimeout = useIsFeatureEnabled(
		FLAGS.NEW_SENSOR_SYSTEM_TESTS_TIMEOUT,
	);

	const asyncTestsTimeoutSec = systemTestsTimeout
		? parseInt(`${systemTestsTimeout}`)
		: 60;

	return {
		asyncTestsTimeoutMs: asyncTestsTimeoutSec * 1000,
	};
};

export default useFeatureFlagConfiguration;
